export default __webpack_public_path__ + "static/media/home-tablet.1f9245ba.jpg";